import { Grid, GridCell } from "@shared/primitive-components"
import { usePolicyAndFleet } from "../../../contexts"
import { ConnectivityStatsSemiDonutChart } from "./charts/ConnectivityStatsSemiDonutChart"
import { CoverStatsDoughnut } from "./charts/CoverStatsDoughnut"
import * as styles from "./styles/fleetListChartStyles"

export const FleetListCharts = () => {
  const { connectivity } = usePolicyAndFleet()
  const loading = connectivity.loading || !connectivity?.data

  return (
    <Grid css={styles.chartWrap}>
      <GridCell span={6} css={styles.chartItem}>
        <CoverStatsDoughnut outerLoading={loading} stats={connectivity.data ?? null} />
      </GridCell>
      <GridCell span={6} css={styles.chartItem}>
        <ConnectivityStatsSemiDonutChart outerLoading={loading} stats={connectivity.data ?? null} />
      </GridCell>
    </Grid>
  )
}
